const TRACKING_SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbxNW_huXqeHs9qwTavuq9rk5CwA1Rp3UJUjwYftv0gvO0L20C5QZpVP9NTtYXcKHSBB/exec";

var SESSION_ID =
  "sess_" + Date.now() + "_" + Math.random().toString(36).slice(2, 8);

function sendTrackingEvent(eventName) {
  var payload = JSON.stringify({
    session_id: SESSION_ID,
    event: eventName,
    timestamp: new Date().toISOString(),
    url: window.location.href,
  });
  fetch(TRACKING_SCRIPT_URL, {
    method: "POST",
    mode: "no-cors",
    keepalive: true,
    body: payload,
  });
}

// Event 1 — raw click on checkout button, before anything else can intercept it
document.addEventListener(
  "click",
  function (e) {
    if (e.target.closest(".cd_checkoutbnt__out")) {
      sendTrackingEvent("checkout_btn_clicked");
    }
  },
  true,
);
